/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Sehr gut`
};

const en_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Very good`
};

const es_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Muy bien`
};

const fr_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Très bien`
};

const it_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Molto bene`
};

const nl_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Zeer goed`
};

const pt_poi_card__review__very_good = /** @type {(inputs: {}) => string} */ () => {
	return `Tudo bem`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__very_good = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_card__review__very_good(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_card__review__very_good", locale)
	if (locale === "de") return de_poi_card__review__very_good(inputs)
	if (locale === "en") return en_poi_card__review__very_good(inputs)
	if (locale === "es") return es_poi_card__review__very_good(inputs)
	if (locale === "fr") return fr_poi_card__review__very_good(inputs)
	if (locale === "it") return it_poi_card__review__very_good(inputs)
	if (locale === "nl") return nl_poi_card__review__very_good(inputs)
	return pt_poi_card__review__very_good(inputs)
};